import { optional } from '@lib/iots';
import * as t from 'io-ts';

export const localLead = t.type({
    email: t.string,
    phone: optional(t.string),
    firstName: t.string,
    lastName: t.string,
    bedrooms: t.number,
    bathrooms: t.number,
    address: t.string,
    googlePlaceId: t.string,
});

export type LocalLead = t.TypeOf<typeof localLead>;
